<template>
  <div class="toasts">
    <transition-group name="slide-fade">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast"
        :class="`toast--${toast.type}`"
      >
        <button
          class="toast__dismiss tb-btn tb-btn-text"
          data-test="toast-dismiss"
          @click="dismiss(toast.id)"
        >
          <span class="fas fa-times" />
        </button>

        <div class="toast__icon margin-right-md">
          <i
            v-if="toast.type === 'connect'"
            class="fas fa-link"
          />
          <i
            v-else-if="toast.type === 'disconnect'"
            class="fas fa-unlink"
          />
          <i
            v-else-if="toast.type === 'success'"
            class="fas fa-check-circle"
          />
          <i
            v-else
            class="fas fa-exclamation-triangle"
          />
        </div>

        <div class="flex-grow">
          <p class="toast__title margin-bottom-xs">
            {{ toast.title }}
          </p>

          <p>{{ toast.message }}</p>

          <a
            v-if="toast.link"
            class="toast__link mt-3 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded border-0 bg-producer-button-primary px-4 py-2 text-sm font-semibold text-white no-underline transition hover:bg-producer-button-primaryHover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            :href="toast.link"
            target="_blank"
            rel="noopener"
            data-test="toast-link"
          >
            <span>{{ toast.linkLabel || 'Open' }}</span>
            <span class="fas fa-external-link-alt text-xs" />
          </a>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  computed: {
    toasts() {
      return this.$store.state.screens.outputToasts || [];
    },
  },

  methods: {
    ...mapActions(['dismissOutputToast']),

    dismiss(id) {
      this.dismissOutputToast(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.toasts {
  z-index: 1000;
  position: fixed;
  bottom: calc(0.5rem + 40px);
  right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.toast {
  position: relative;
  border-left: 4px solid #26c5da;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  background: #121212;
  padding: 1rem 2rem;
  border-radius: 4px;
  display: flex;
  align-items: center;

  .toast__icon .fas {
    font-size: 24px;
  }
}

.toast--connect {
  border-left-color: #26c5da;
}

.toast--success {
  border-left-color: #26c5da;
}

.toast--disconnect {
  border-left-color: #e65447;
}

.toast--error {
  border-left-color: #f5a623;
}

.toast__title {
  font-weight: bold;
  font-size: 1.1em;
}

.toast__dismiss {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  padding: 0.16rem;
  line-height: 1;
  color: rgba(255, 255, 255, 0.4);
  border: none;
  background: none;
  cursor: pointer;

  .fas {
    font-size: 16px;
  }

  &:hover {
    color: #fff;
  }
}
</style>
